import { useParams } from "react-router-dom"
import { getAdminToken } from "../../utils/helpers"
import Button from "../ReusableElements/Button/Button"
import { Col, Row } from "antd"

const FormButtons = ({handleClose,isDisable,isLoading}) => {
    const token = getAdminToken()
    const {id} = useParams()
    const route = `/new-entry/details/${id}`
    return (
        <>
        {
            (token && window.location.pathname !== route) && 
            <Row className={'display-flex-justify-end'} gutter={16}>
            <Col xs={12}>
                <Button className={'button'} onClick={handleClose} buttonText={"Cancel"} />
            </Col>
            <Col xs={12}>
                <Button type="primary" className={'button'} buttonText={isLoading? "Uploading...": "Submit"} htmlType="submit" isDisable={isDisable? isDisable : false}/>
            </Col>
        </Row>
        }
        </>
    )
}

export default FormButtons